import { makeStyles } from '@mui/styles';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const useStyles = makeStyles((theme: any) => ({
  positionEnd: {
    marginRight: theme.spacing(-1)
  },
  InputAdornmentRoot: {
    color: 'rgba(0, 0, 0, 0.26)'
  }
}));
